import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ name }) {
        return (
            <email-unsub-opt-in>
                <aside class='small-12 medium-6 medium-push-6 columns'>
                    <img src='https://gfx.tarot.com/images/site/tarot/unsub/3cups.gif' alt='3 of Cups' />
                </aside>
                <main class='small-12 medium-6 medium-pull-6 columns'>
                    <header>
                        <h1>WELCOME BACK</h1>
                        <h2>This Calls for A Celebration!</h2>
                        <hr />
                        <h3>You will continue receiving <b>{name}</b> emails.</h3>
                    </header>
                    <div class='row'>
                        <div class='small-12 medium-10 end columns'>
                            <a href='/daily-horoscope' class='button-warning-alternate'>GET TODAY'S INSIGHT</a>
                        </div>
                    </div>
                    <div class='row'>
                        <div class='small-12 medium-10 end columns'>
                            <a href='#opt-out' class='button-warning'>OOPS! UNSUBSCRIBE ME</a>
                        </div>
                    </div>
                    <br />
                    <a href='/member/emails' class='manage'>Manage your email preferences</a>
                    <br />
                </main>
            </email-unsub-opt-in>
        );
    }
}

const mapStateToProps = (state) => ({
    name: state['email-unsub'] && state['email-unsub'].name,
});

export default connect(mapStateToProps)(Component);





// WEBPACK FOOTER //
// ./app/components/member/email-unsub-opt-in.js